// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"4788": "b91968ede32f","8696": "bbb68422bd59","9737": "0f55f421ba7d",}[chunkId] + ".css"
}